import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiAlertCircle, mdiOpenInNew, mdiPencilOutline } from "@mdi/js";
import moment from "moment-timezone";
import { formatMoney } from "app/containers/Jobs/utils/format";
import { compiledReportUrl } from "utils/helperFunctions/compiledReportUrl";
import InfoIconSlot from "./InfoIconSlot";
import "./JobPopover.css";

const openInNewTab = (url) => window.open(url, "_blank", "noopener,noreferrer");

const QuoteValue = ({ job }) => (
  <span className="job-info-value">
    {job?.quote ? (
      <span>{formatMoney(job.quote)}</span>
    ) : (
      <span className="no-quote">
        No quote yet
        <Icon
          path={mdiAlertCircle}
          size="16px"
          className="job-popover-inline-icon"
        />
      </span>
    )}
    {job?.note && (
      <InfoIconSlot text={job.note} iconClassName="job-note-info-icon" />
    )}
  </span>
);

// Section template and quote, shown once the job is past "booked".
export const JobSetupInfo = ({ appointment }) => (
  <>
    <div className="job-popover-divider" />
    <div className="job-info">
      <div className="job-info-row">
        <span className="job-info-label">Section Template</span>
        <span className="job-info-value">
          {appointment.job?.template?.name || "Standard Sections"}
        </span>
      </div>
      <div className="job-info-row">
        <span className="job-info-label">Quote</span>
        <QuoteValue job={appointment.job} />
      </div>
    </div>
  </>
);

const InspectionResults = ({ report }) => (
  <>
    <div className="job-popover-divider" />
    <div className="job-info">
      <div className="job-info-row">
        <span className="job-info-label">Inspection Results</span>
        <span className="job-info-value">
          {report.item_count} {report.item_count === 1 ? "item" : "items"}{" "}
          recorded
          {report.id && (
            <Button
              variant="link"
              className="inspection-results-edit-link"
              onClick={() => openInNewTab(`/reports/${report.id}/edit`)}
            >
              <Icon
                path={mdiPencilOutline}
                size="16px"
                className="job-popover-edit-icon"
              />
              Edit
            </Button>
          )}
        </span>
      </div>
    </div>
  </>
);

const CompiledReport = ({ compiledReport }) => (
  <>
    <div className="job-popover-divider" />
    <div className="job-info">
      <div className="job-info-row">
        <span className="job-info-label">Report</span>
        <span className="job-info-value">
          {moment(compiledReport.created_at).format("MM/DD/YYYY HH:mm:ss")}{" "}
          compiled
          <Button
            variant="link"
            className="job-popover-icon-btn job-popover-open-link"
            onClick={() => openInNewTab(compiledReportUrl(compiledReport.id))}
            aria-label="Open compiled report in a new tab"
          >
            <Icon path={mdiOpenInNew} size="20px" />
          </Button>
        </span>
      </div>
    </div>
  </>
);

// Inspection progress, then the compiled report (completed jobs only).
export const JobResultsInfo = ({ appointment, showReport }) => {
  const report = appointment.job?.report;
  return (
    <>
      {report?.item_count > 0 && <InspectionResults report={report} />}
      {showReport && report?.compiled_report?.created_at && (
        <CompiledReport compiledReport={report.compiled_report} />
      )}
    </>
  );
};
